"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterOrLoginUnauthenticatedCommand = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var AdobeDataLayerHelper_1 = require("@ferry/customer-portal/src/utils/AdobeDataLayerHelper");
// This command determines from the uiState, if a user already is registered with us.
var RegisterOrLoginUnauthenticatedCommand = /** @class */ (function (_super) {
    __extends(RegisterOrLoginUnauthenticatedCommand, _super);
    function RegisterOrLoginUnauthenticatedCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegisterOrLoginUnauthenticatedCommand.prototype.exec = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var setRegistration, minutes, millis;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                setRegistration = (_a = this.getSetting("setRegistration", props.journeyEventDefinition.settings)) !== null && _a !== void 0 ? _a : false;
                minutes = 1;
                millis = minutes * 60 * 1000;
                // If the user has been found and their details match, these cookies help keycloak to redirect to login page
                if (props.interaction.uistate.isExistingUser && !setRegistration) {
                    (0, commonFunctions_1.setCookie)("isExistingUser", true, millis);
                    (0, commonFunctions_1.setCookie)("userFirstName", props.interaction.policyHolder.firstName, millis);
                }
                else {
                    // If the user is not found, this cookie redirects them to registration.
                    (0, commonFunctions_1.setCookie)("registerUnauthenticated", true, millis);
                }
                setTimeout(function () {
                    var isAuthenticated = _this.applicationGuard.isAuthenticated();
                    if (isAuthenticated) {
                        (0, AdobeDataLayerHelper_1.pushEventToAdobeDataLayer)("registrationSuccess");
                    }
                }, 2000);
                return [2 /*return*/, _super.prototype.exec.call(this, props)];
            });
        });
    };
    return RegisterOrLoginUnauthenticatedCommand;
}(plugin_journey_1.AuthenticateCommand));
exports.RegisterOrLoginUnauthenticatedCommand = RegisterOrLoginUnauthenticatedCommand;
//# sourceMappingURL=RegisterOrLoginUnauthenticatedCommand.js.map